import React from "react";
import DashboardStyle from "../../Styles/Dashboard.module.css";
import { FiPlus } from "react-icons/fi";
import { useFormContext } from "react-hook-form";
import { toast } from "react-toastify";
import { PerfectFileUpload } from "../Forms/InputTemplate";

function FormUploader({
  uploadFile,
  setUploadFile,
  vendorDocument,
  setVendorDocument,
}) {
  const { getValues, setValue, watch } = useFormContext();

  return (
    <div className={DashboardStyle.inputs_group_no_grid}>
      <div>
        <PerfectFileUpload
          setFile={setUploadFile}
          file={uploadFile}
          title={""}
          isOptional={false}
          camcelCase={"stuff"}
          handleChange={(cac) => {
            setUploadFile(cac);
          }}
        />
        <button
          type="button"
          style={{
            color: "var(--primary-color)",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            gap: "5px",
          }}
          onClick={(e) => {
            e.preventDefault();
            const fileName = getValues("fileName");
            if (uploadFile && fileName && fileName.trim() !== "") {
              // console.log('documentList',documentList);
              // console.log('vendorDocument',vendorDocument);
              setVendorDocument([
                ...vendorDocument,
                {
                  file: uploadFile,
                  fileName: fileName,
                },
              ]);

              setUploadFile(null);
              setValue("fileName", "");
            } else {
              toast.error("File Name or File can not be empty");
            }
          }}
        >
          <FiPlus />
          <p>Add</p>
        </button>
      </div>
    </div>
  );
}

export default FormUploader;
